import React, { useEffect, useRef, useState } from 'react';

// Importuj polyfill do Resize Observera
import 'resize-observer-polyfill';

// Definicja interfejsu dla obiektu zmiany rozmiaru
interface ResizeObserverEntry {
  contentRect: DOMRectReadOnly;
}

// Własny hook do monitorowania zmiany rozmiaru elementu
export function useResizeObserver<T extends HTMLElement>(): [
  React.RefObject<T>,
  DOMRectReadOnly | null,
] {
  const ref = useRef<T>(null);
  const [entry, setEntry] = useState<DOMRectReadOnly | null>(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      if (entries && entries.length > 0) {
        setEntry(entries[0].contentRect);
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return [ref, entry];
}
